<template>
  <v-row class="fill-height" no-gutters>
    <v-col cols="4" class="left-column d-flex justify-center align-center">
      <div class="welcome">
        <img
          class="mb-3"
          :src="loginConfig.avenue_login_config_logo_url"
          style="max-width: 300px; max-height: 300px width: auto; height: auto"
        />
        <div class="welcome-main">
          Welcome to
          <span class="amp">AMP</span> Avenue
        </div>
        <div class="welcome-sub">Login or request access from here</div>
      </div>
    </v-col>
    <v-col cols="8" class="right-column">
      <v-card class="elevation-12" width="800">
        <v-toolbar color="#75ae46" dark flat>
          <v-toolbar-title>Login</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field
              v-model="email"
              label="Email"
              prepend-icon="person"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="password"
              label="Password"
              prepend-icon="lock"
              type="password"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-alert v-if="error" type="error" dense tile>{{ error }}</v-alert>
          <div class="flex-grow-1"></div>
          <v-btn color="#75ae46" @click="login()" :loading="isLogin"
            >Login</v-btn
          >
        </v-card-actions>
      </v-card>
      <div class="custom-message">
        {{ loginConfig.avenue_login_config_custom_message }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,
    email: "",
    password: "",
    isLogin: false,
    error: "",
  }),
  computed: {
    loginConfig: function () {
      return this.$store.state.loginConfig;
    },
  },
  methods: {
    login: async function () {
      var payload = {
        email: this.email,
        password: this.password,
      };
      try {
        this.isLogin = true;
        await this.$store.dispatch("login", payload);
        this.$router.push(
          `/Manufacturers/${this.$store.state.manufacturerId}/Avenue/Path`
        );
      } catch (error) {
        this.error = error;
      } finally {
        this.isLogin = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.left-column {
  background-color: #75ae46;
  color: white;

  .welcome {
    padding: 60px;
    font-weight: 300;

    .welcome-main {
      font-size: 32px;
    }
    .welcome-sub {
      font-size: 14px;
      font-style: italic;
    }

    .amp {
      font-weight: bold;
    }
  }
}

.right-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.custom-message {
  position: absolute;
  bottom: 50px;
  font-weight: bold;
  margin: 0px 20px;
  text-align: center;
}
</style>